<template>
  <div class="container" style="display: flex; flex-direction: row; margin-top: 8px;">
    <div style="width: 620px;">
      <div>
        <el-button
            type="primary"
            icon="el-icon-s-promotion"
            @click="generateCover">
          生成头像
        </el-button>
        <el-button
            type="primary"
            icon="el-icon-s-promotion"
            @click="generateCover2">
          生成情头
        </el-button>
      </div>
      <el-slider v-model="period" :min="100" :max="2000" show-input :step="100"></el-slider>
      <div style="margin-top: 16px; width: 480px;background: #FFCCCC;">
        <div style="margin-top: 8px; width: 480px;background: #CCFFCC;">
          背景色：
          <el-color-picker v-model="backgroundColor"></el-color-picker>
          边框色：
          <el-color-picker v-model="borderColor"></el-color-picker>
        </div>
      </div>
      <Tinymce
          v-model="result1"
          ref="editor1"
          :width="620"
          :height="640"
          style="margin-top: 8px;"/>
    </div>
    <canvas ref="cover" style="width: 200px; height: 200px; border: #333333 solid 1px; margin-left: 16px;"/>
  </div>
</template>
<script>
import Tinymce from '@/Tinymce';

let ctx, canvas, width = 1080, height = 1080, topPadding, padding2 = 8, gwbjlBgImg, wxDoubleImg;
let testImg;
const devicePixelRatio = 1;//window.devicePixelRatio;
export default {
  name: "DyAvatarGenerator",
  components: {Tinymce},
  data() {
    return {
      gzh: 0,
      startGifUrl: "",
      recommendGzhStart: 0,
      recommendGzhEnd: 0,
      urlInput: '',
      result: "",
      hasStart: 0,
      hasEnd: 0,
      footType: 0,
      shadowType: 0,
      waterMarkType: 0,
      activeTab: "result1",
      result1: "",
      result2: "",
      result3: "",
      result4: "",
      result5: "",
      result6: "",
      result7: "",
      result8: "",
      roted: 0,
      backgroundColor: '#FFFFFF',
      borderColor: '#000000',
      leftVerticalMargin: (width - ((width - padding2) / 2)) / 2,
      rightVerticalMargin: (width - ((width - padding2) / 2)) / 2,
      bzwLeftVerticalMargin: 0,
      bzwRightVerticalMargin: 0,
      verticalMargin: 0,
      downloadedImage: new Map(),
      period: parseInt(window.localStorage.getItem("dy_avatar_period")) || 800,
    }
  },
  mounted() {
    let that = this;
    topPadding = (width - height) / 2 - 2;
    // 背景图
    gwbjlBgImg = new Image();
    gwbjlBgImg.src = require('@/assets/gwbjl_bg.jpg');
    gwbjlBgImg.crossOrigin = '';
    testImg = new Image();
    testImg.src = require('@/assets/logo.png');
    testImg.crossOrigin = '';
    //情侣头像背景图
    wxDoubleImg = new Image();
    wxDoubleImg.src = require('@/assets/two_header.jpg');
    wxDoubleImg.crossOrigin = '';
    canvas = this.$refs.cover;
    ctx = canvas.getContext("2d");
    ctx.mozImageSmoothingEnabled = false;
    ctx.webkitImageSmoothingEnabled = false;
    ctx.msImageSmoothingEnabled = false;
    ctx.imageSmoothingEnabled = false;
    canvas.width = width * devicePixelRatio;
    canvas.height = height * devicePixelRatio;
    //ctx.scale(devicePixelRatio, devicePixelRatio);
  },
  methods: {
    generateCover22() {
      let that = this;
      ctx.fillStyle = that.backgroundColor;
      ctx.fillRect(0, 0, width, height);
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = 0;
      ctx.shadowColor = 'rgba(0,0,0,0.5)';
      ctx.shadowBlur = 24;
      //ctx.fillRect(64, 64, width - 128, height - 128);
      ctx.drawImage(testImg, 120, 540, 400, 400);
      ctx.drawImage(testImg, 560, 540, 400, 400);
      ctx.drawImage(wxDoubleImg, 126, 180, wxDoubleImg.width, wxDoubleImg.height);
      ctx.shadowBlur = 0;
      ctx.drawImage(testImg, 158, 201, 96, 96);
      ctx.drawImage(testImg, 158, 345, 96, 96);
    },
    generateCover() {
      window.localStorage.setItem("dy_avatar_period", this.period);
      this.downloadedImage = new Map();
      let that = this;
      // 遍历所有图片
      let imgArr = this.result1.split("<img");
      for (let i = 1; i < imgArr.length; i++) {
        let imgTemp = imgArr[i];
        imgTemp = imgTemp.substring(imgTemp.indexOf(" src=\"") + 6);
        imgTemp = imgTemp.substring(0, imgTemp.indexOf("\""));
        that.$api
            .post('https://api.cuntubang.com/CwHelper/forceDownloadResource',
                {
                  unionId: '123',
                  //resourceType: that.resourceType,
                  webUrl: imgTemp,
                  imgUrlList: [imgTemp]
                })
            .then(response => {
              if (response.data.resultCode === 0 && response.data.imgUrlList && response.data.imgUrlList.length > 0) {
                let img = new Image();
                img.onload = function () {
                  that.downloadedImage.set(i - 1, img);
                  let downloadedImageSize = that.downloadedImage.size;
                  if (downloadedImageSize === imgArr.length - 1) {
                    let index = 0;
                    let imgIndex = 0;
                    let files = new Map();
                    while (imgIndex < downloadedImageSize) {
                      let f = index % 2;
                      let img1 = that.downloadedImage.get(imgIndex);
                      if (f === 1) {
                        ctx.fillStyle = that.backgroundColor;
                        ctx.fillRect(0, 0, width, height);
                        ctx.shadowBlur = 0;
                        ctx.drawImage(img1, 0, 0, width, height);
                        const findex = index;
                        canvas.toBlob(function(blob){
                          files.set(findex, new File([blob], findex + ".jpg", { type: "image/jpeg" }));
                          if (files.size === downloadedImageSize * 2) {
                            that.imageToMp4(files);
                          }
                        });
                      } else {
                        ctx.fillStyle = that.backgroundColor;
                        ctx.fillRect(0, 0, width, height);
                        ctx.shadowOffsetX = 0;
                        ctx.shadowOffsetY = 0;
                        ctx.shadowColor = 'rgba(0,0,0,0.5)';
                        ctx.shadowBlur = 24;
                        ctx.drawImage(gwbjlBgImg, (width - gwbjlBgImg.width) / 2, (height - gwbjlBgImg.height) / 2, gwbjlBgImg.width, gwbjlBgImg.height);
                        ctx.drawImage(img1, 700, 120, 300, 300);
                        ctx.shadowBlur = 0;
                        ctx.drawImage(img1, 181, 476, 130, 130);
                        const findex = index;
                        canvas.toBlob(function(blob){
                          files.set(findex, new File([blob], findex + ".jpg", { type: "image/jpeg" }));
                          if (files.size === downloadedImageSize * 2) {
                            that.imageToMp4(files);
                          }
                        });
                      }
                      index++;
                      imgIndex = parseInt(index / 2);
                    }
                  }
                }
                img.src = response.data.imgUrlList[0];
                img.crossOrigin = '';
              }
            });
      }
    },
    generateCover2() {
      window.localStorage.setItem("dy_avatar_period", this.period);
      this.downloadedImage = new Map();
      let that = this;
      // 遍历所有图片
      let imgArr = this.result1.split("<img");
      for (let i = 1; i < imgArr.length; i++) {
        let imgTemp = imgArr[i];
        imgTemp = imgTemp.substring(imgTemp.indexOf(" src=\"") + 6);
        imgTemp = imgTemp.substring(0, imgTemp.indexOf("\""));
        that.$api
            .post('https://api.cuntubang.com/CwHelper/forceDownloadResource',
                {
                  unionId: '123',
                  //resourceType: that.resourceType,
                  webUrl: imgTemp,
                  imgUrlList: [imgTemp]
                })
            .then(response => {
              if (response.data.resultCode === 0 && response.data.imgUrlList && response.data.imgUrlList.length > 0) {
                let img = new Image();
                img.onload = function () {
                  that.downloadedImage.set(i - 1, img);
                  let downloadedImageSize = that.downloadedImage.size;
                  if (downloadedImageSize === imgArr.length - 1) {
                    let index = 0;
                    let imgIndex = 0;
                    let files = new Map();
                    while ((imgIndex + 1) < downloadedImageSize) {
                      let f = index % 3;
                      let img1 = that.downloadedImage.get(imgIndex);
                      let img2 = that.downloadedImage.get(imgIndex + 1);
                      if (f === 2) {
                        ctx.fillStyle = that.backgroundColor;
                        ctx.fillRect(0, 0, width, height);
                        ctx.shadowBlur = 0;
                        ctx.drawImage(img2, 0, 0, width, height);
                        const findex = index;
                        canvas.toBlob(function(blob){
                          files.set(findex, new File([blob], findex + ".jpg", { type: "image/jpeg" }));
                          if (files.size === parseInt(downloadedImageSize * 3 / 2)) {
                            that.imageToMp4(files);
                          }
                        });
                      } else if (f === 1) {
                        ctx.fillStyle = that.backgroundColor;
                        ctx.fillRect(0, 0, width, height);
                        ctx.shadowBlur = 0;
                        ctx.drawImage(img1, 0, 0, width, height);
                        const findex = index;
                        canvas.toBlob(function(blob){
                          files.set(findex, new File([blob], findex + ".jpg", { type: "image/jpeg" }));
                          if (files.size === parseInt(downloadedImageSize * 3 / 2)) {
                            that.imageToMp4(files);
                          }
                        });
                      } else {
                        ctx.fillStyle = that.backgroundColor;
                        ctx.fillRect(0, 0, width, height);
                        ctx.shadowOffsetX = 0;
                        ctx.shadowOffsetY = 0;
                        ctx.shadowColor = 'rgba(0,0,0,0.5)';
                        ctx.shadowBlur = 24;
                        //ctx.fillRect(32, 32, width - 64, height - 64);
                        ctx.drawImage(img1, 120, 540, 400, 400);
                        ctx.drawImage(img2, 560, 540, 400, 400);
                        ctx.drawImage(wxDoubleImg, 126, 180, wxDoubleImg.width, wxDoubleImg.height);
                        ctx.shadowBlur = 0;
                        ctx.drawImage(img1, 158, 201, 96, 96);
                        ctx.drawImage(img2, 158, 345, 96, 96);
                        const findex = index;
                        canvas.toBlob(function(blob){
                          files.set(findex, new File([blob], findex + ".jpg", { type: "image/jpeg" }));
                          if (files.size === parseInt(downloadedImageSize * 3 / 2)) {
                            that.imageToMp4(files);
                          }
                        });
                      }
                      index++;
                      imgIndex = parseInt(index / 3) * 2;
                    }
                  }
                }
                img.src = response.data.imgUrlList[0];
                img.crossOrigin = '';
              }
            });
      }
    },
    roundRect(x, y, w, h, r) {
      var min_size = Math.min(w, h);
      if (r > min_size / 2) r = min_size / 2;
      // 开始绘制
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.closePath();
      ctx.strokeStyle = this.borderColor;
      ctx.lineWidth = 2;
      ctx.stroke();
    },
    drawRoundedRect(x, y, width, height, radius) {
      ctx.moveTo(x + radius, y)
      ctx.lineTo(x + width - radius, y)
      ctx.arc(x + width - radius, y + radius, radius, 1.5 * Math.PI, 2 * Math.PI)
      ctx.lineTo(x + width, y + height - radius)
      ctx.arc(x + width - radius, y + height - radius, radius, 0, 0.5 * Math.PI)
      ctx.lineTo(x + radius, y + height)
      ctx.arc(x + radius, y + height - radius, radius, 0.5 * Math.PI, 1 * Math.PI)
      ctx.lineTo(x, y + radius)
      ctx.arc(x + radius, y + radius, radius, 1 * Math.PI, 1.5 * Math.PI)
      ctx.strokeStyle = this.borderColor;
      ctx.lineWidth = 2;
      ctx.stroke();
    },
    imgRoundRect (x, y, w, h, r) {
      var min_size = Math.min(w, h);
      if (r > min_size / 2) r = min_size / 2;
      // 开始绘制
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.closePath();
    },
    onLeftVerticalMarginChange(value) {
      this.leftVerticalMargin = value;
    },
    downloadCover() {
      const MIME_TYPE = "image/png";
      var imgURL = canvas.toDataURL(MIME_TYPE, 1.0);
      var dlLink = document.createElement('a');
      dlLink.download = "cover.png";
      dlLink.href = imgURL;
      dlLink.dataset.downloadurl = [MIME_TYPE, dlLink.download, dlLink.href].join(':');
      document.body.appendChild(dlLink);
      dlLink.click();
      document.body.removeChild(dlLink);
    },
    //下载文件
    downloadFile(url, fileName) {
      // 创建隐藏的可下载链接
      var eleLink = document.createElement('a');
      eleLink.download = fileName;
      eleLink.style.display = 'none';
      eleLink.href = url;
      // 触发点击
      document.body.appendChild(eleLink);
      eleLink.click();
      // 然后移除
      document.body.removeChild(eleLink);
    },
    imageToMp4(files) {
      let that = this;
      var formData = new FormData();
      formData.append('period', that.period);
      for (let j = 0; j < files.size; j++) {
        formData.append('image' + j, files.get(j));
      }
      that.$api
          .post('http://192.168.31.145:8084/homeip/imagesToMp4',
              formData, {
                responseType: 'blob',
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              })
          .then(response2 => {
            let mblob = response2.data;
            let mblobUrl = URL.createObjectURL(mblob);
            that.downloadFile(mblobUrl, that.randomString(6) + '.mp4')
          });
    },
    randomString(e) {
      e = e || 32;
      var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
          a = t.length,
          n = "";
      for (let i = 0; i < e; i++) {
        n += t.charAt(Math.floor(Math.random() * a));
      }
      return n;
    }
  }
};
</script>

<style>
</style>